import * as React from "react";
import { useFormContext } from "react-hook-form";
import NGAlert from "../../../newcomponents/alert";
import { DomainInput } from "./types/input";

interface Props {}
export const CreateNGAdvancedPortsDedicatedLBCheck: React.FC<Props> = () => {
  const { watch } = useFormContext<DomainInput>();

  const fRoutingMode = watch("advanced.spec.routingMode");

  const gvcName = watch("gvc.name");
  const workloadName = watch("advanced.spec.workload.name");

  const fPorts = watch("advanced.spec.ports") || [];

  const dedicatedLoadBalancerRequirement: {
    isRequired: boolean;
    reason: string;
  } = React.useMemo(() => {
    let isRequired = false;
    let reason = "";

    for (const port of fPorts) {
      if (String(port.number) !== "443" && String(port.number) !== "80" && port.protocol === "tcp") {
        isRequired = true;
        reason = "numbertcp";
      } else if (String(port.number) !== "443" && String(port.number) !== "80") {
        isRequired = true;
        reason = "number";
      } else if (port.protocol === "tcp") {
        isRequired = true;
        reason = "tcp";
      }
    }

    return { isRequired, reason };
  }, [fPorts]);

  if (fRoutingMode === "workloadSubdomain" && (!workloadName || !gvcName)) {
    return null;
  }

  if (fRoutingMode === "pathBased" && !gvcName) {
    return null;
  }

  return (
    <>
      {dedicatedLoadBalancerRequirement.isRequired ? (
        <>
          {dedicatedLoadBalancerRequirement.reason === "numbertcp" ? (
            <NGAlert
              type={`warning`}
              className="mb-4"
              title={`Dedicated Load Balancer is Required`}
              message={`Domain with ports using TCP protocol and port numbers other than 443 and 80 requires Dedicated Load Balancer on the GVC that it is targeting`}
            />
          ) : null}

          {dedicatedLoadBalancerRequirement.reason === "number" ? (
            <NGAlert
              type={`warning`}
              className="mb-4"
              title={`Dedicated Load Balancer is Required`}
              message={`Domain with ports using port numbers other than 443 and 80 requires Dedicated Load Balancer on the GVC that it is targeting`}
            />
          ) : null}

          {dedicatedLoadBalancerRequirement.reason === "tcp" ? (
            <NGAlert
              type={`warning`}
              className="mb-4"
              title={`Dedicated Load Balancer is Required`}
              message={`Domain with ports using TCP protocol requires Dedicated Load Balancer on the GVC that it is targeting`}
            />
          ) : null}
        </>
      ) : null}
    </>
  );
};
